import React from "react";
import { Clock, Utensils, LifeBuoy, Users, MessageCircle, Check, Info } from "lucide-react";
import { FULL_DAY_EXCURSION, EXCURSIONS, buildWhatsAppLink } from "../mock/mock";

const Tarifs = () => {
  return (
    <section id="tarifs" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-10">
          <span className="inline-block bg-[#FFC93C] text-[#0B2545] text-xs font-black tracking-widest px-3 py-1 rounded-full">
            NOS TARIFS
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl font-black text-[#0B2545]">
            Grand Cul-de-Sac Marin — Journée complète
          </h2>
          <p className="mt-4 text-slate-700 max-w-4xl mx-auto leading-relaxed">
            {FULL_DAY_EXCURSION.description}
          </p>
          <div className="mt-4 inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-900 text-xs md:text-sm font-semibold px-4 py-2 rounded-full">
            <Info className="h-4 w-4" />
            {FULL_DAY_EXCURSION.disclaimer}
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Left: Info */}
          <div className="bg-[#0B2545] text-white rounded-2xl p-7 shadow-xl">
            <div className="space-y-6">
              <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-full bg-[#FFC93C]/15 border border-[#FFC93C]/40 flex items-center justify-center shrink-0">
                  <Clock className="h-5 w-5 text-[#FFC93C]" />
                </div>
                <div>
                  <div className="text-[#FFC93C] text-xs font-bold tracking-widest">DÉPART</div>
                  <div className="font-bold text-lg">{FULL_DAY_EXCURSION.departure}</div>
                  <div className="text-white/70 text-sm">{FULL_DAY_EXCURSION.departurePoint}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-full bg-[#FFC93C]/15 border border-[#FFC93C]/40 flex items-center justify-center shrink-0">
                  <Utensils className="h-5 w-5 text-[#FFC93C]" />
                </div>
                <div>
                  <div className="text-[#FFC93C] text-xs font-bold tracking-widest">INCLUS</div>
                  <div className="font-bold">Apéritif + Repas + Dessert</div>
                  <div className="text-white/70 text-sm italic">Repas by Besson Grill Plus</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-full bg-[#FFC93C]/15 border border-[#FFC93C]/40 flex items-center justify-center shrink-0">
                  <LifeBuoy className="h-5 w-5 text-[#FFC93C]" />
                </div>
                <div>
                  <div className="text-[#FFC93C] text-xs font-bold tracking-widest">NON FOURNI</div>
                  <div className="font-bold">Masques, tubas et palmes</div>
                  <div className="text-white/70 text-sm">À prévoir par vos soins</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-full bg-[#FFC93C]/15 border border-[#FFC93C]/40 flex items-center justify-center shrink-0">
                  <Users className="h-5 w-5 text-[#FFC93C]" />
                </div>
                <div>
                  <div className="text-[#FFC93C] text-xs font-bold tracking-widest">PETIT GROUPE</div>
                  <div className="font-bold">{FULL_DAY_EXCURSION.groupSize}</div>
                  <div className="text-white/70 text-sm">Places limitées — Réservez vite !</div>
                </div>
              </div>
            </div>
          </div>

          {/* Middle: Prices */}
          <div className="bg-gradient-to-br from-[#FFC93C] to-[#FFB800] rounded-2xl p-7 shadow-xl relative overflow-hidden">
            <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-white/20" />
            <div className="absolute -bottom-6 -left-6 h-24 w-24 rounded-full bg-white/10" />
            <div className="relative">
              <div className="inline-block bg-[#0B2545] text-[#FFC93C] text-xs font-black tracking-widest px-3 py-1 rounded-full">
                TARIFS
              </div>
              <div className="mt-8 space-y-6">
                {FULL_DAY_EXCURSION.prices.map((p, i) => (
                  <div key={i} className="pb-4 border-b border-[#0B2545]/20 last:border-0">
                    <div className="flex items-end justify-between">
                      <div className="text-[#0B2545] font-bold text-sm tracking-widest uppercase">
                        {p.label}
                      </div>
                      <div className="text-[#0B2545] font-black text-4xl leading-none">
                        {p.value === 0 ? "GRATUIT" : `${p.value} €`}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <a
                href={buildWhatsAppLink("Bonjour, je souhaite réserver la journée Grand Cul-de-Sac Marin.")}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 flex items-center justify-center gap-2 w-full bg-[#0B2545] hover:bg-[#134074] text-white font-bold py-3 rounded-xl transition"
              >
                <MessageCircle className="h-5 w-5" fill="white" strokeWidth={0} />
                RÉSERVER
              </a>
            </div>
          </div>

          {/* Right: Program */}
          <div className="bg-white rounded-2xl p-7 shadow-xl border border-slate-100">
            <h3 className="font-black text-[#0B2545] text-xl">Au programme</h3>
            <p className="text-slate-500 text-sm mt-1">L&apos;expérience complète Gwadaplaisance</p>
            <ul className="mt-5 space-y-3">
              {FULL_DAY_EXCURSION.program.map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="h-6 w-6 rounded-full bg-[#25D366]/10 flex items-center justify-center shrink-0 mt-0.5">
                    <Check className="h-4 w-4 text-[#25D366]" />
                  </span>
                  <span className="text-slate-700 font-medium">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Small excursions summary */}
        <div className="mt-14">
          <h3 className="text-2xl font-black text-[#0B2545] text-center mb-6">Excursions à la carte</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {EXCURSIONS.map((ex) => (
              <div
                key={ex.id}
                className="flex items-center justify-between bg-slate-50 rounded-xl p-4 border border-slate-100 hover:border-[#25D366]/40 hover:bg-white transition"
              >
                <div>
                  <div className="font-bold text-[#0B2545]">{ex.title}</div>
                  <div className="text-xs text-slate-500">{ex.duration}</div>
                </div>
                <div className="text-[#25D366] font-black text-2xl">{ex.price}€</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tarifs;
